import { AppRegistry } from 'react-native'

import App from 'app/src/App'

AppRegistry.registerComponent('ElAuction', () => App)
AppRegistry.runApplication('ElAuction', {
  rootTag: document.getElementById('root'),
})
